import { createGetApi } from "@api/util/createGetApi";

import { setPassword } from "./setPassword/api";

import type { IApiResponse } from "@api";
import type { IUserGetAllParams } from "@api/users/types";
import type { IUserMeResponse } from "src/api/users/me/types";

import type { IPathBaseParam } from "./path";

const getApis = createGetApi<
  IApiResponse<IUserMeResponse>,
  IPathBaseParam,
  Pick<IUserGetAllParams, "includes">
>("users.me");

export const me = {
  ...getApis,
  setPassword,
};
